export const VENDOR_CONTACT_TYPES = [
  "Mail_Personal",
  "Mail_Office",
  "Phone_Home",
  "Phone_Mobile",
  "Phone_Office",
] as const;

export const VENDOR_MAIL_CONTACT_TYPES = [
  "Mail_Personal",
  "Mail_Office",
] as const;

export const VENDOR_PHONE_CONTACT_TYPES = [
  "Phone_Home",
  "Phone_Mobile",
  "Phone_Office",
] as const;

export type VendorContactType = (typeof VENDOR_CONTACT_TYPES)[number];

export const DEFAULT_VENDOR_CONTACT_TYPE: VendorContactType = "Mail_Personal";
export const DEFAULT_VENDOR_MAIL_CONTACT_TYPE: VendorContactType =
  "Mail_Personal";
export const DEFAULT_VENDOR_PHONE_CONTACT_TYPE: VendorContactType =
  "Phone_Mobile";

export const isMailVendorContactType = (type: string | null | undefined) =>
  type?.startsWith("Mail_") ?? false;

export const isPhoneVendorContactType = (type: string | null | undefined) =>
  type?.startsWith("Phone_") ?? false;

export const parseVendorBooleanField = (
  value: unknown,
  defaultValue: boolean,
): boolean => {
  if (value === true || value === "True" || value === "TRUE") {
    return true;
  }
  if (value === false || value === "False" || value === "FALSE") {
    return false;
  }
  return defaultValue;
};

export const vendorBooleanToExcel = (value: boolean) =>
  value ? "True" : "False";
